import React from 'react';
import PropTypes from 'prop-types';
import Message from './message';
import withTracking from '../../../utils/tracking/components/withTracking';
import { defaultClick } from '../../../utils/tracking/events/pageEvents';
import EventModel from '../../../utils/tracking/models';

function SignupWidget(props) {
  console.log('props', props);
  return (
    <div className="signup-widget">
      <input
        type="email"
        id="email"
        className={`signup-widget__email ${
          !props.disabled ? 'signup-widget__email--editable' : ''
        }`}
        value={props.value}
        placeholder={props.placeholder}
        onChange={props.handleChange}
        disabled={!props.emailEditable || props.disabled}
        ref={props.setFocus}
      />
      <label className="visually-hidden" htmlFor="email">
        Email
      </label>
      <br />
      {props.captcha ? props.captcha : ''}
      <button
        className={`signup-widget__button ${
          props.emailFormError ? 'signup-widget__button--disabled' : ''
        } ${
          props.emailEditable
            ? 'signup-widget__button'
            : `signup-widget__button--no-border`
        }`}
        onClick={() => {
          if (props.disabled) {
            window.location.href = '/';
            return;
          }
          // console.log('submit email clicked');
          // [DataLayer] trigger nav item click event
          const clickEvent = new EventModel(
            'Newsletter Signup Submit Click',
            `formLanderSubmit`,
            'newsletterLander',
            `newsletter lander submitted`
          );
          props.trackClick(clickEvent.getTrackingObject());
          // eslint-disable-next-line
          props.emailEditable ? props.handleSubmit : props.toggleInputOn;
          props.handleSubmit();
          // console.log('email editable', props.emailEditable, 'handleSubmit', props.handleSubmit);
        }}
        disabled={props.emailFormError}
        type="button"
      >
        {props.buttonText}
      </button>
      <p style={{ marginBottom: '0px', marginTop: '20px' }}>{props.status}</p>

      <div className="signup-widget__message-container">
        <Message type="error" message={props.emailUpdateMessageError} />
        <Message type="success" message={props.emailUpdateSuccessMessage} />
        <Message type="error" message={props.emailFormError} />
      </div>
    </div>
  );
}

SignupWidget.defaultProps = {
  buttonText: 'Submit',
  emailFormError: '',
  setFocus: () => {},
  emailUpdateMessageError: '',
  emailUpdateSuccessMessage: '',
  emailEditable: true,
  status: '',
  placeholder: 'You Email Address',
  toggleInputOn: () => {},
  disabled: false,
  trackClick: () => false,
  captcha: false
};

SignupWidget.propTypes = {
  emailUpdateMessageError: PropTypes.string,
  emailUpdateSuccessMessage: PropTypes.string,
  emailEditable: PropTypes.bool,
  buttonText: PropTypes.string,
  status: PropTypes.string,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setFocus: PropTypes.func,
  toggleInputOn: PropTypes.func,
  emailFormError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  trackClick: PropTypes.func,
  captcha: PropTypes.element
};

const mapTrackingToProps = trackEvent => ({
  trackClick: pageObject => trackEvent(defaultClick(pageObject))
});

const trackedSignupWidget = withTracking(mapTrackingToProps)(SignupWidget);

export default trackedSignupWidget;
